<app-grid>
  <app-cell mobile="0:12" tablet="0:8" laptop="0:4" desktop="0:4">
    <div class="reset-password">

      <div class="reset-password__text">
        <h1>
          {{'auth.reset-password' | translate}}
        </h1>
      </div>

      <app-input [placeholder]="'my-data.enter-new-password' | translate"
        [control]="resetPasswordForm | formChild: 'password' : 'control'"
        [errorMessages]="passwordService.passwordErrorMessages"
        [type]="passwordService.passwordFormType"
        icon="show"
        (iconAction)="passwordService.changeFormType()"
        >
        {{'my-data.new-password' | translate}}
      </app-input>

      <div class="reset-password__bottom-form">
        <app-input [placeholder]="'my-data.confirm-your-password' | translate"
          [control]="resetPasswordForm | formChild: 'passwordConfirmation' : 'control'"
          [errorMessages]="passwordService.passwordErrorMessages"
          [type]="passwordService.passwordFormType"
          icon="show"
          (iconAction)="passwordService.changeFormType()"
          >
          {{'my-data.confirm-password' | translate}}
        </app-input>
      </div>

      @if (resetPasswordForm.getError('noMatchingPassword')) {
        <label
          class="error-message small"
          >
          {{'validation.messages.no-passwords-match' | translate}}
        </label>
      }

      @if (graphqlErrors.length) {
        <div>
          <div class="errors">
            @for (item of graphqlErrors; track item) {
              <ul>
                <li >
                  {{ item | translate }}
                </li>
              </ul>
            }
          </div>
        </div>
      }

      <app-button theme="dark"
        layout="label-only"
        (click)="submit()"
        class="reset-password__button"
        >
        {{'common.submit' | translate}}
      </app-button>
    </div>
  </app-cell>
</app-grid>
